import { render } from "./AddressList.vue?vue&type=template&id=2f5ff7c0&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=2f5ff7c0&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-meter-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5ff7c0"],['__file',"src/assets/js/pages/MeterConfig/AddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f5ff7c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f5ff7c0', __exports__)) {
    api.reload('2f5ff7c0', __exports__)
  }
  
  module.hot.accept("./AddressList.vue?vue&type=template&id=2f5ff7c0&scoped=true", () => {
    api.rerender('2f5ff7c0', render)
  })

}


export default __exports__